import React from "react";
import "./BonsaiQueryForm.css";
import Modal from "react-modal";
//import logo from "../assets/images/pubmed-logo.png";

interface BonsaiQueryFormProps {
  isOpen: boolean;
  onRequestClose: () => void;
  bonsaiTopic: string;
  setBonsaiTopic: (topic: string) => void;
  handleBonsaiQuery: () => void;
}

const BonsaiQueryForm: React.FC<BonsaiQueryFormProps> = ({
  isOpen,
  onRequestClose,
  bonsaiTopic,
  setBonsaiTopic,
  handleBonsaiQuery,
}) => {

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)"
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "50%",
    height: "65%",
    borderRadius: "10px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#fff",
  },
};
  
  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={onRequestClose}
      contentLabel="Bonsai Query Modal"
    >
      <div className="bonsai-query-modal-content">
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: "5px", marginBottom: "-5px" }}>
          {/* <img src={logo} alt="PubMed Logo" style={{ height: "50px", marginRight: "10px" }} /> */}
          <div className="bonsai-query-title">Bonsai Climate Footprint Analyzer</div>
        </div>
        <label className="bonsai-query-label">Ask PubMed about your topic of interest:</label>
        <textarea
          className="bonsai-query-modal-input"
          placeholder="Enter topic here..." 
          value={bonsaiTopic}
          onChange={(e) => setBonsaiTopic(e.target.value)}
          rows={5}
        />
        <div className="row">
          <button className="modal-button-left" onClick={handleBonsaiQuery}>
            Query
          </button>
          <button className="modal-button-left" onClick={onRequestClose}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default BonsaiQueryForm;
